export * from './kunde-post-request.interface';
export * from './kunde-post-response.interface';
export * from './kunde-post.shapes';
